import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';

export default function (): any {
  const cookie = Cookies.get('user_v2');
  if (cookie) {
    const user = JSON.parse(cookie);
    if (user) {
      if (window && (window as any).Sentry) {
        // Attach the user to the Sentry reporting agent
        Sentry.configureScope((scope: any) => {
          scope.setUser({
            id: user.id,
            name: user.name,
            email: user.email,
            groups: user.groups,
            isExternal: user.isExternal,
          });
        });
      }
      return user;
    }

    return null;
  }
  return null;
}
